<template>
  <div class="align-center">
    <v-row class="buttons-diapos">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn small dense class="btn_palette mr-2" :disabled="!selectedIsDocumento" @click="actionDocument()"
            v-on="on">
            <v-icon small>{{ dataBtnDocumento.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ dataBtnDocumento.tooltip }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn small dense class="btn_palette mr-2" :disabled="!selectedIsVideoOrAudio" @click="ReplayMediaSelected()"
            v-on="on">
            <v-icon small>fas fa-retweet</v-icon>
          </v-btn>
        </template>
        <span>Replay</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn small dense class="btn_palette mr-2" :disabled="!selectedIsVideoOrAudio" @click="StopMediaSelected()"
            v-on="on">
            <v-icon small>fas fa-stop</v-icon>
          </v-btn>
        </template>
        <span>Stop</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn small dense class="btn_palette mr-2" :disabled="!selectedIsVideoOrAudio"
            @click="PlayPauseMediaSelected()" v-on="on">
            <v-icon small>{{ dataBtnReproduciendo.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ dataBtnReproduciendo.tooltip }}</span>
      </v-tooltip>

      <v-menu offset-y :close-on-content-click="false" max-width="250">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small dense class="btn_palette mr-2" v-bind="attrs" v-on="on">
            <v-icon small>fa-paint-brush</v-icon>
          </v-btn>
        </template>
        <v-container fluid style="background-color: white;">

          <!-- <div style="display: inline-block; margin-left: 10px"> -->

          <v-row>
            <v-col cols="12" class="pb-0">
              <v-badge offset-x="6" offset-y="6" :color="ColorDrawOnOff" dot bordered>
                <v-btn @click="toggleModeDraw" x-small :color="buttonInitActivate.color" dark>
                  <v-icon x-small>{{ buttonInitActivate.icon }}</v-icon>
                  &nbsp;{{ buttonInitActivate.title }} </v-btn>
              </v-badge>

            </v-col>


            <v-col cols="12" class="pb-0 py-1">
              <v-badge offset-x="6" offset-y="6" :color="ColorSelOnOff" dot bordered>
                <v-btn @click="toggleModeSelected" x-small :color="buttonInitSelected.color" dark>
                  <v-icon x-small>{{ buttonInitSelected.icon }}</v-icon>
                  &nbsp;{{ buttonInitSelected.title }} </v-btn>
              </v-badge>
            </v-col>

            <v-col cols="12" class="py-0" :class="ColorDrawOnOff == 'green' ? '' : 'pb-2'">
              <v-btn @click="GroupingAll" class="grey darken-1 mt-2" x-small dark><v-icon x-small> far
                  fas fa-object-group</v-icon> &nbsp;Agrupar
              </v-btn>
            </v-col>


            <v-col v-if="false" cols="12" class="py-0">
              <v-btn @click="AddTexto()" class="orange darken-1 mt-2" x-small dark><v-icon x-small>fas
                  fa-font</v-icon> &nbsp;Agregar Texto
              </v-btn>
            </v-col>

            <v-col cols="12" v-if="ColorDrawOnOff == 'green'" class="py-0">
              <v-btn @click="clearCanvas" class="mt-2" x-small color="warning" dark><v-icon x-small> fa-solid
                  fa-trash</v-icon>&nbsp;Limpiar
              </v-btn>
            </v-col>

            <v-col v-if="ColorDrawOnOff == 'green'" cols="12" class="pt-1">
              <!-- <v-icon class="mr-2" small>fa-paint-brush</v-icon> -->
              <v-select @change="selectMode()" v-model="modoPincel" dense :items="modosPincel" item-text="modo"
                item-value="valor" return-object single-line>
                <template #prepend>
                  <v-icon x-small class="mt-1">fa-paint-brush</v-icon>
                </template>
                <template v-slot:label>
                  <span style="color:#000000de; font-size: 14px;">Selecciona pincel </span>
                  <!-- Change the color as needed -->
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip small v-if="index === 0">
                    <span>{{ item.modo }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    {{ modoPincel }}
                  </span>
                </template>
              </v-select>
            </v-col>

            <v-col v-if="ColorDrawOnOff == 'green'" cols="12" class="py-0">
              <v-slider @change="selectGrosorPincel" dense :thumb-size="24" thumb-label="always"
                v-model="drawingLineWidthEl" :max="max" :min="min" hide-details>
                <template v-slot:label>
                  <span style="color:#000000de; font-size: 14px;">Grosor: <v-icon x-small
                      class="mb-1">fa-paint-brush</v-icon></span> <!-- Change the color as needed -->
                </template>
              </v-slider>
            </v-col>

            <v-col v-if="ColorDrawOnOff == 'green'" cols=12 class="pt-0">
              <label style="color:#000000de; font-size: 15px;">Color: <v-icon x-small
                  class="mb-1 pr-5">fa-paint-brush</v-icon></label>
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn width="60" x-small :color="drawingColorEl" dark v-on="on"></v-btn>
                </template>
                <v-color-picker @input="selectColorPincel" v-model="drawingColorEl" dot-size="25"
                  swatches-max-height="200"></v-color-picker>
                <!-- hide-canvas hide-inputs 
                  show-swatches -->
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </v-menu>

      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            small
            dense
            class="btn_palette mr-2"
            @click="PlayPauseMediaSelected()"
            v-on="on"
          >
            <v-icon small>fa-paint-brush</v-icon>
          </v-btn>
        </template>
        <span>Estilizar lámina</span>
      </v-tooltip> -->

    </v-row>
    <!-- ESTE ROW CONTIENE LAS DIAPOSITIVAS -->
    <!-- <v-row class="pa-0 ma-0"> -->
    <!-- START Contenido Diapositiva -->
    <!-- <v-col cols  class="pt-0"> -->
    <div ref="canvasKWSP" class="contentCanvas mt-2">
      <canvas :id="`canvasVisor${presentacion.id}${fullWindows ? 'F' : ''}`" class="canvasKWST">
      </canvas>
    </div>
    <!-- </v-col> -->
    <!-- END Contenido Diapositiva  :style="{ width: '98%', height: 'auto' }"-->
    <!-- </v-row> -->
    <!-- Contenido Diapositiva end -->

    <component :is="compName" :estadoComp="estadoModalConfig" @close="CloseComponent" :parametros="parametroConfig">
    </component>
  </div>
</template>

<script>
import "@/assets/css/gestor_contenido.css";


import brushIconURL from "../../../../../assets/iconos/pincel.png";
import brushIconSprayURL from "../../../../../assets/iconos/spray.png";
import {
  VideoIcon,
  AudioIcon,
  PDFIcon,
  // WordIcon,
  // XLSIcon,
  // XLSXIcon,
  BUCKET_ORIGIN_SPACE,
} from "@/helpers/axios";
import { fabric } from "fabric";
import videojs from "video.js";

import LectorDocumentComp from "@/views/Manager/GestionContenido/creadorContenido/gcDiapostiva/lector/document";
import LectorImageComp from "@/views/Manager/GestionContenido/creadorContenido/gcDiapostiva/lector/image";

export default {
  name: "vistadiapositiva",
  props: {
    presentacion: {
      type: Object,
    },
    fullWindows: {
      type: Boolean,
    },
    screenDocument: {
      type: Boolean,
    },
  },
  components: {
    LectorDocumentComp,
    LectorImageComp,
  },

  data() {
    return {
      URL_SPACE: BUCKET_ORIGIN_SPACE,
      visualizar_imagen: false,
      setImagen: "",
      timecomputed: new Date().getTime(),
      test: false,
      datos: {},
      timestamp: `/${new Date().getTime()}`,
      color_fondo: "#FFFFFF",
      canvas: null,
      widthScene: null,
      heightScene: null,
      objectSelected: null,
      compName: "",
      estadoModalConfig: false,
      parametroConfig: {},
      // config video.js for full screem
      videoOptions: {
        autoplay: true,
        controls: true,
        bigPlayButton: false,
        sources: [
          {
            src: "",
            type: "video/mp4",
          },
        ],
        controlBar: {
          pictureInPictureToggle: true,
        },
      },
      player: null,
      //EDICION DE DIIAPOSITIVA - DIBUJAR, PINTAR.
      modoPincel: { modo: 'Modo: Pencil', valor: 'Pencil' },
      // { modo: 'Pencil', valor: 'Pencil' }
      modosPincel: [
        { modo: 'Modo: Pincel', valor: 'Pencil' },
        { modo: 'Modo: Circulo', valor: 'Circle' },
        { modo: 'Modo: Spray', valor: 'Spray' },
        // { modo: 'Modo: Pattern', valor: 'Pattern' },
        // { modo: 'Modo: hline', valor: 'hline' },
        // { modo: 'Modo: vline', valor: 'vline' },
        // { modo: 'Modo: square', valor: 'square' },
        // { modo: 'Modo: diamond', valor: 'diamond' },
        // { modo: 'Modo: texture', valor: 'texture' },
      ],
      drawingLineWidthEl: 0,
      min: 0,
      max: 150,
      drawingColorEl: 'black',
      buttonInitActivate: { color: 'green', icon: 'fa-solid fa-power-off', title: 'Activar modo dibujo' },
      ColorDrawOnOff: 'grey',
      buttonInitSelected: { color: 'primary', icon: 'fas fa-mouse-pointer', title: 'Activar modo selección' },
      ColorSelOnOff: 'grey',
      vLinePatternBrush: null,
      hLinePatternBrush: null,
      squarePatternBrush: null,
      diamondPatternBrush: null,
      texturePatternBrush: null,

    };

  },
  computed: {
    selectedIsVideoOrAudio() {
      if (this.objectSelected == null) return false;
      const tipo = this.objectSelected.data.type || "";
      return tipo == "video" || tipo == "audio";
    },
    dataBtnReproduciendo() {
      if (this.objectSelected == null) {
        return {
          icon: "fas fa-play",
          tooltip: "Play",
        };
      }
      const reproduciendo = this.objectSelected.data.run;
      return reproduciendo
        ? {
          icon: "fas fa-pause",
          tooltip: "Pause",
        }
        : {
          icon: "fas fa-play",
          tooltip: "Play",
        };
    },
    selectedIsDocumento() {
      if (this.objectSelected == null) return false;
      const tipo = this.objectSelected.data.type || "";
      return tipo == "documento";
    },
    dataBtnDocumento() {
      if (this.objectSelected == null || !this.selectedIsDocumento) {
        return {
          icon: "fa-solid fa-book-open",
          tooltip: "Leer documento",
        };
      }

      let pathExt = this.objectSelected.data.file_desc
        .split(".")
        .at(-1)
        .toLowerCase();

      // SI ES PDF DEBE DE HABRRIR UN MODAL PARA LEERLO
      if (this.objectSelected.data.file_ext == ".pdf" || pathExt == "pdf") {
        return {
          icon: "fa-solid fa-book-open",
          tooltip: "Leer documento",
        };
      } else {
        return {
          icon: "fas fa-file-download",
          tooltip: "Descargar documento",
        };
      }
    },
    cacheDinamica() {
      const tm = this.timecomputed;
      return `?nocache=${tm}`;
    },
  },
  watch: {
    color_fondo(newValor) {
      this.EventBackground(newValor);
    },

    screenDocument(val) {

      console.log('val', val);
      this.onWindowResize(val);
    }

  },
  mounted() {
    this.LoadMain();
  },
  beforeDestroy() {
    // Limpiar contenedor de videojs al iniciar el componente
    this.objectSelected == null;
    // document.getElementById("videoPlayer").innerHTML = "";
    this.DetenerVideosYAudios();
  },
  methods: {
    /**
     ____________________________________________
    |          MÉTODOS CARGAR INICIAL          */
    LoadMain() {

      this.timecomputed = new Date().getTime();
      // document.getElementById("videoPlayer").innerHTML = "";
      this.objectSelected = null;

      this.CargarDiapositiva(this.presentacion.canvas);

      // BORRAR OBJETOS CON SUPRIMIR
      document.onkeydown = (e) => {
        if (this.objectSelected && e.which == 46) {
          this.BorrarObject();
        }
      };

    },
    /**
     _______________________________________________
    |          MÉTODOS ESTILO BACKGROUND          */
    EventBackground(valor) {
      this.presentacion.background = valor;
      let color = `${valor.substring(0, 7)}`;
      this.canvas.backgroundColor = color;
      this.Render();
    },
    /**
     ____________________________________________________________
    |          MÉTODOS REAJUSTAR TAMAÑO LIENZO CANVAS          */
    onWindowResize(fullWindows) {

      if (this.$refs.canvasKWSP) {

        this.widthScene = this.$refs.canvasKWSP.clientWidth - (fullWindows ? this.screenDocument ? 100 : 350 : 10);
        this.heightScene = (this.widthScene * (fullWindows ? this.screenDocument ? 54 : 52 : 55)) / 100;

        if (this.canvas.width != this.widthScene) {
          let scaleMultiplier = this.widthScene / this.canvas.width;
          let objects = this.canvas.getObjects();
          for (let i in objects) {
            if (objects[i].data.type != "video" || objects[i].data.type != "audio")
              objects[i].selectable = false;
            objects[i].scaleX = objects[i].scaleX * scaleMultiplier;
            objects[i].scaleY = objects[i].scaleY * scaleMultiplier;
            objects[i].left = objects[i].left * scaleMultiplier;
            objects[i].top = objects[i].top * scaleMultiplier;
            objects[i].setCoords();
          }
        }

        this.canvas.setDimensions({
          width: this.widthScene,
          height: this.heightScene,
        });

        this.canvas.setZoom(1);
        this.Render();
        this.canvas.calcOffset();
      }
    },
    /**
     ____________________________________________________
    |          MÉTODOS CREAR INSTANCIA FABRIC          */
    LoadFabric() {

      this.canvas = new fabric.Canvas(`canvasVisor${this.presentacion.id}${this.fullWindows ? "F" : ""}`, {
        selection: false,
        isDrawingMode: false
      });

      this.EventBackground(this.color_fondo);
      this.onWindowResize(this.fullWindows);
      this.canvas.on("selection:created", (obj) => {
        this.objectSelected = obj.selected[0];
      });
      this.canvas.on("selection:updated", (obj) => {
        this.objectSelected = obj.selected[0];
      });
      this.canvas.on("selection:cleared", () => {

        this.objectSelected = null;
      });
      this.canvas.on("path:created", (obj) => {
        let path = obj.path;
        path.data = { type: "dibujo" };
      });


      fabric.util.addListener(this.canvas.upperCanvasEl, "dblclick", () => {

        if (this.objectSelected != null) {
          if (this.objectSelected.data.type == "documento") {
            this.actionDocument();
          } else if (this.objectSelected.data.type == "video") {
            this.ViewFullScreemVideo();
          } else if (this.objectSelected.data.type == "imagen") {
            this.ViewImage();
          }
        }
      });

      fabric.util.requestAnimFrame(this.Render);
    },

    /**
     _________________________________________________________
    |          MÉTODOS ACTUALIZAR INSTANCIA FABRIC          */
    Render() {
      this.canvas.renderAll();
      fabric.util.requestAnimFrame(this.Render);
    },
    /**
     _____________________________________________________________
    |          MÉTODOS SOBRE ESTILOS BORDES DEL CANVAS          */
    setStyleCorner(objeto) {
      if (objeto.data.type == "texto")
        objeto.setControlsVisibility({
          tl: false,
          mt: false,
          tr: false,
          bl: false,
          mb: false,
          br: false,
        });
      (objeto.cornerColor = "white"),
        (objeto.cornerStrokeColor = "black"),
        (objeto.cornerStyle = "circle");
    },
    /**
     _______________________________________________________
    |          MÉTODOS RECREAR ETIQUETA DE VIDEO          */
    ActualizarElementoVideo(obj) {
      let videoElem = this.SetUpVideo(obj.data.fileLink);
      // let videoElem = document.getElementById('video1');
      videoElem.onloadeddata = () => {
        videoElem.width = videoElem.videoWidth;
        videoElem.height = videoElem.videoHeight;
        let group = obj.getObjects()[1];
        let video1 = group.getObjects()[0];
        group.objectCaching = false;
        video1.setElement(videoElem);
        video1.visible = true;
        obj.data.element = videoElem;
        obj.objectCaching = false;
        this.Render();
      };
    },
    /**
     _____________________________________________________
    |          MÉTODOS CREAR ETIQUETA DE VIDEO          */
    SetUpVideo(source) {
      // <video class="video-js"></video>;
      // let videoPlayerParent = document.getElementById("videoPlayer");
      let _videoDOMElement = document.createElement("video");
      // _videoDOMElement.classList.add("video-js");

      // _videoDOMElement.setAttribute('style', 'display:none;');
      _videoDOMElement.setAttribute("id", "videoJs");
      _videoDOMElement.setAttribute("preload", "auto");
      _videoDOMElement.setAttribute("playsinline", "playsinline");
      _videoDOMElement.setAttribute("webkit-playsinline", "webkit-playsinline");
      _videoDOMElement.muted = false;
      _videoDOMElement.autoplay = false;
      _videoDOMElement.controls = true;
      _videoDOMElement.crossOrigin = "anonymous";

      let nSourceDOMElement = document.createElement("source");
      nSourceDOMElement.src = source;
      nSourceDOMElement.type = "video/mp4";
      _videoDOMElement.appendChild(nSourceDOMElement);

      // videoPlayerParent.appendChild(_videoDOMElement);
      return _videoDOMElement;
    },
    /**
     _____________________________________________________
    |          MÉTODOS CREAR ETIQUETA DE AUDIO          */
    SetUpAudio(source) {
      let audioDOMElement = document.createElement("audio");
      // performance
      audioDOMElement.controls = "controls";
      audioDOMElement.autoplay = false;
      audioDOMElement.crossOrigin = "anonymous";

      let sourceDOMElement = document.createElement("source");
      sourceDOMElement.src = source;
      audioDOMElement.appendChild(sourceDOMElement);

      return audioDOMElement;
    },
    /**
     _______________________________________________________
    |          MÉTODOS RECREAR ETIQUETA DE AUDIO          */
    ActualizarElementoAudio(obj) {
      let audioElem = this.SetUpAudio(obj.data.fileLink);
      obj.data.element = audioElem;
      this.Render();
    },
    /**
     _________________________________________________
    |          MÉTODOS CARGAR DIAPOSITIVAS          */
    CargarDiapositiva(canvas) {


      console.log({ canvas });


      this.LoadFabric();
      if (canvas) {
        if (canvas.objects != undefined) {
          canvas.objects = canvas.objects.map((item) => {
            switch (item.data.type) {
              case "imagen":
                if (!item.src.includes('https://')) {
                  item.data.fileLink = this.URL_SPACE + item.src + this.cacheDinamica;
                  return { ...item, src: this.URL_SPACE + item.src + this.cacheDinamica };
                } else {
                  item.data.fileLink = item.src;
                  return { ...item, src: item.src };
                }

              case "video":

                if (!item.objects[1].objects[1].src.includes(this.URL_SPACE)) {
                  item.objects[1].objects[1].src = this.URL_SPACE + VideoIcon;
                  item.data.fileLink = this.URL_SPACE + item.data.fileLink;

                  console.log("canvasrecod", item.data.fileLink);

                  return { ...item };

                } else if (!item.data.fileLink.includes('https://')) {

                  item.data.fileLink = this.URL_SPACE + item.data.fileLink + this.cacheDinamica;
                  return { ...item, src: this.URL_SPACE + item.data.fileLink + this.cacheDinamica };

                } else {
                  return { ...item };
                }

              case "documento":
                if (!item.objects[0].src.includes(this.URL_SPACE)) {
                  item.objects[0].src = this.URL_SPACE + PDFIcon;
                  item.data.fileLink = this.URL_SPACE + item.data.fileLink;
                  return { ...item };
                } else {
                  return { ...item };
                }

              case "audio":
                if (!item.src.includes(this.URL_SPACE)) {
                  item.src = this.URL_SPACE + AudioIcon;
                  item.data.fileLink = this.URL_SPACE + item.data.fileLink;
                  return { ...item };
                } else {
                  return { ...item };
                }

              default:
                return { ...item };
            }
          });
        }

        // this.canvas.clear();
        this.canvas.loadFromJSON(canvas, () => {
          let videosSinElemento = this.canvas
            .getObjects()
            .filter(
              (obj) =>
                obj.data.type == "video" &&
                (JSON.stringify(
                  obj.getObjects()[1].getObjects()[0].getElement()
                ) === "{}" ||
                  obj.getObjects()[1].getObjects()[0].getElement() == null)
            );

          videosSinElemento.forEach((obj) => {
            this.ActualizarElementoVideo(obj);
          });

          let audiosSinElemento = this.canvas
            .getObjects()
            .filter(
              (obj) =>
                obj.data.type == "audio" &&
                (JSON.stringify(obj.data.element) === "{}" ||
                  obj.data.element == null)
            );
          audiosSinElemento.forEach((obj) => {
            this.ActualizarElementoAudio(obj);
          });

          // let textosSinFondo = this.canvas
          //   .getObjects()
          //   .filter(
          //     (obj) => obj.data.type == "texto" && !obj.data.backgroundColor
          //   );
          // textosSinFondo.forEach((obj) => {
          //   obj.set("backgroundColor", `#FFFFFF00`);
          //   obj.data.backgroundColor = `#FFFFFF00`;
          // });


          let objects = this.canvas.getObjects();

          let canvasJ =
            typeof canvas === "object" ? canvas : JSON.parse(canvas);
          if (
            canvasJ.hasOwnProperty("widthScene") &&
            canvasJ["widthScene"] != this.widthScene
          ) {
            let scaleMultiplier = this.widthScene / canvasJ["widthScene"];
            for (var i in objects) {
              objects[i].scaleX = objects[i].scaleX * scaleMultiplier;
              objects[i].scaleY = objects[i].scaleY * scaleMultiplier;
              objects[i].left = objects[i].left * scaleMultiplier;
              objects[i].top = objects[i].top * scaleMultiplier;
              objects[i].setCoords();
            }
          }
          // for (let index = 0; index < objects.length; index++) {
          //   this.setStyleCorner(objects[index]);
          // }

          this.MovementLocked(true);
          this.Render();
        });
      }
    },
    /**
     ____________________________________________________
    |          MÉTODOS VER DOCUMENTO EN MODAL          */
    async actionDocument() {
      let pathExt = this.objectSelected.data.file_desc
        .split(".")
        .at(-1)
        .toLowerCase();

      // SI EL PDF DEBE DE HABRIR UN MODAL PARA LEERLO
      if (this.objectSelected.data.file_ext == ".pdf" || pathExt == "pdf") {
        this.parametroConfig = {
          fileLink: this.objectSelected.data.fileLink,
          fileDesc: this.objectSelected.data.file_desc,
          file_ext: this.objectSelected.data.file_ext,
        };
        this.compName = "LectorDocumentComp";
        this.estadoModalConfig = true;
      } else {
        fetch(this.objectSelected.data.fileLink).then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", this.objectSelected.data.file_desc);
          document.body.appendChild(fileLink);

          fileLink.click();
        });
      }
    },
    /**
     ______________________________________________________
    |          MÉTODOS VER EN PANTALLA COMPLETA          */
    ViewFullScreemVideo() {
      // document.getElementById("videoPlayer").style.display = "block";
      this.estadoModalConfig = true;
      this.videoOptions.sources[0].src = this.objectSelected.data.fileLink;

      const playVideoInFullscreen = () => {
        if (!this.player.isFullscreen()) {
          this.player.requestFullscreen();
          // this.player.enterFullWindow();
        } else {
          this.exitFullscreen();
          document.documentElement.style.overflow = 'hidden';
        }
      };

      if (this.player) {
        if (this.videoOptions.sources[0].src != this.objectSelected.data.fileLink) {
          this.player.src(this.videoOptions.sources[0]);
        }
        playVideoInFullscreen();
      } else {

        this.player = videojs(document.getElementById("videoJs"), this.videoOptions, () => {

          let objects = this.objectSelected.getObjects()[1].getObjects();
          let elementVideo = objects[0].getElement();


          elementVideo.play();


          playVideoInFullscreen();

          this.player.on("play", () => {
            this.objectSelected.data.run = true;
            objects[0].visible = true;
            objects[1].visible = false;
          });

          this.player.on("pause", () => {
            this.objectSelected.data.run = false;
            objects[0].visible = false;
            objects[1].visible = true;
          });
          // CUANDO SALES DEL REPRODUCTOR VIDEOJS
          this.player.on("fullscreenchange", () => {
            this.estadoModalConfig = false;
            if (!this.player.isFullscreen()) {
              document.documentElement.style.overflow = "hidden";
              // document.getElementById("videoPlayer").style.display = "none";
              let currentTime = this.player.currentTime();
              elementVideo.setAttribute("preload", "auto");
              elementVideo.src = this.videoOptions.sources[0].src;
              elementVideo.currentTime = currentTime;
              elementVideo.play();
              this.Render();
            }
          });
        }
        );
      }
    },
    /**
     _________________________________________________
    |          MÉTODOS VER IMAGEN EN MODAL          */
    ViewImage() {
      if (this.objectSelected.data.fileLink) {
        this.parametroConfig = {
          fileLink: this.objectSelected.data.fileLink,
        };
        this.compName = "LectorImageComp";
        this.estadoModalConfig = true;
      }
    },
    /**
     _________________________________________________________________
    |          MÉTODOS ACCION PAUSAR RECURSO VIDEO - AUDIO          */
    PlayPauseMediaSelected() {
      // this.objectSelected.data.type

      if (this.objectSelected.data.type == "video") {




        let objectsVideo = this.objectSelected.getObjects()[1].getObjects();
        let elementVideo = objectsVideo[0].getElement();


        console.log({ objectsVideo });
        console.log({ elementVideo });



        if (this.objectSelected.data.run == true) {

          elementVideo.pause();
          this.objectSelected.data.run = false;
          // objectsVideo[0].visible = false;
          objectsVideo[1].visible = true;
        } else {
          elementVideo.play();
          this.objectSelected.data.run = true;
          objectsVideo[0].visible = true;
          objectsVideo[1].visible = false;
        }
        this.Render();



      } else if (this.objectSelected.data.type == "audio") {

        if (this.objectSelected.data.run == true) {
          this.objectSelected.data.element.pause();
          this.objectSelected.data.run = false;
        } else {
          this.objectSelected.data.element.play();
          this.objectSelected.data.run = true;
        }
      }
    },
    /**
     ____________________________________________________________________
    |          MÉTODOS ACCION REPLAY RECURSO VIDEO - AUDIO             */
    ReplayMediaSelected() {
      if (this.objectSelected.data.type == "video") {
        let objectsVideo = this.objectSelected.getObjects()[1].getObjects();
        let elementVideo = objectsVideo[0].getElement();
        elementVideo.pause();
        elementVideo.currentTime = "0";
        objectsVideo[0].visible = true;
        objectsVideo[1].visible = false;
        this.Render();
        elementVideo.play();
      } else if (this.objectSelected.data.type == "audio") {
        this.objectSelected.data.element.pause();
        this.objectSelected.data.element.currentTime = 0;
        this.objectSelected.data.element.play();
      }
      this.objectSelected.data.run = true;
    },
    /**
     ________________________________________________________________
    |          MÉTODOS ACCION PARAR RECURSO VIDEO - AUDIO          */
    StopMediaSelected() {
      if (this.objectSelected.data.type == "video") {
        let objectsVideo = this.objectSelected.getObjects()[1].getObjects();
        let elementVideo = objectsVideo[0].getElement();
        elementVideo.pause();
        elementVideo.currentTime = "0";
        objectsVideo[0].visible = false;
        objectsVideo[1].visible = true;
        this.Render();
      } else if (this.objectSelected.data.type == "audio") {
        this.objectSelected.data.element.pause();
        this.objectSelected.data.element.currentTime = 0;
      }
      this.objectSelected.data.run = false;
    },
    /**
     ______________________________________________________
    |          MÉTODOS ACCION DETENER RECURSOS           */
    DetenerVideosYAudios() {
      if (this.canvas) {
        this.canvas
          .getObjects()
          .filter(
            (obj) =>
              obj.data && (obj.data.type == "audio" || obj.data.type == "video")
          )
          .forEach((obj) => {
            if (
              obj.data.type == "audio" &&
              obj.data.element &&
              typeof obj.data.element.pause === "function"
            ) {
              obj.data.element.pause();
              obj.data.element.currentTime = 0;
              obj.data.run = false;
            } else if (
              obj.data.type == "video" &&
              obj.getObjects()[1].getObjects()[0].getElement()
            ) {
              let elementVideo = obj
                .getObjects()[1]
                .getObjects()[0]
                .getElement();
              // if (JSON.stringify(elementVideo) != "{}" && elementVideo != null) {
              if (elementVideo instanceof HTMLVideoElement) {
                elementVideo.pause();
                elementVideo.currentTime = 0;
                elementVideo.remove();
              } else if (
                obj.data.element &&
                typeof obj.data.element.pause === "function"
              ) {
                try {
                  obj.data.element.pause();
                } catch (error) {
                  console.log(error);
                }
                obj.data.element.currentTime = 0;
              }
              obj.data.run = false;
            }
          });
      }
    },

    /**
    ══════════════════════════════════════════════════
    ║         MÉTODOS DRAWIN LIENZO CANBAS           ║
    ════════════════════════════════════════════════*/
    /**
     _____________________________________________
    |          MÉTODO TOGGLE SELECTOR           */
    toggleModeSelected() {
      this.canvas.selection = !this.canvas.selection;
      if (this.canvas.selection) {
        this.MovementLocked(false);
        this.ColorSelOnOff = 'green'
        this.buttonInitSelected.title = 'Cancelar modo selección';
        this.buttonInitSelected.icon = 'fas fa-times'
        this.buttonInitSelected.color = 'red'
        if (this.canvas.isDrawingMode) {
          this.toggleModeDraw();
        }
      }
      else {
        this.ColorSelOnOff = 'grey'
        this.buttonInitSelected.title = 'Activar modo selección';
        this.buttonInitSelected.icon = 'fas fa-mouse-pointer'
        this.buttonInitSelected.color = 'primary'
      }
    },
    /**
     ______________________________________________________
    |          MÉTODO TOOGLE EDICION O PINCEL           */
    toggleModeDraw() {
      this.canvas.isDrawingMode = !this.canvas.isDrawingMode;

      if (this.canvas.isDrawingMode) {
        this.canvas.freeDrawingCursor = `url('${brushIconURL}') 0 0, auto`;
        this.ColorDrawOnOff = 'green'
        this.buttonInitActivate.title = 'Cancelar modo dibujo';
        this.buttonInitActivate.icon = 'fa-solid fa-power-off'
        this.buttonInitActivate.color = 'red'
        if (this.canvas.selection) {
          this.toggleModeSelected();
        }
      }
      else {
        this.ColorDrawOnOff = 'grey'
        this.buttonInitActivate.title = 'Activar modo dibujo';
        this.buttonInitActivate.icon = 'fa-solid fa-power-off'
        this.buttonInitActivate.color = 'green'
      }
    },
    /**
     ________________________________________________________
    |          MÉTODO BORRAR OBJETO SELECCIONADO           */
    BorrarObject() {
      let activeObjects = this.canvas.getActiveObjects();
      for (let i = 0; i < activeObjects.length; i++) {
        this.canvas.remove(activeObjects[i]);
      }
    },
    /**
     _______________________________________________
    |          MÉTODO SELECCIONAR TODOS          */
    GroupingAll() {

      this.canvas.discardActiveObject();
      let sel = new fabric.ActiveSelection(this.canvas.getObjects(), {
        canvas: this.canvas,
      });
      this.canvas.setActiveObject(sel);
      this.canvas.requestRenderAll();
    },
    /**
     ___________________________________________
    |          MÉTODO AGREGAR TEXTO           */
    AddTexto() {
      // alert('font size')
      // this.listDiapositivas[this.diapositivaSeleccionada].update = true;
      this.CreateTextFabric("Agregar Texto");
      this.Render();
    },
    /**
     _______________________________________________________
    |          MÉTODO CREACION DE TEXTO FABRIC            */
    CreateTextFabric(texto) {
      let text = new fabric.Textbox(`${texto}`, {
        width: 250,
        fill: "#000000",
        fontFamily: 'Comic Sans MS',
        fontSize: '30',
        textAlign: "center",
        fontWeight: "normal",
        fontVariant: "lowercase",
        fontStyle: "normal",
        originX: "center",
        originY: "center",
        backgroundColor: "#FFFFFF00",
      });
      text.data = {
        type: "texto",
        color: "#000000",
        backgroundColor: "#FFFFFF00",
      };

      this.setStyleCorner(text);
      this.canvas.add(text);
      this.canvas.centerObject(text);
      this.canvas.setActiveObject(text);
      text.enterEditing();
      text.selectAll();

      return text;
    },
    /**
     _______________________________________________________________
    |          MÉTODOS BLOQUEAR MOVIMIENTOS DE ELEMENTOS          */
    MovementLocked(flag) {
      // ESTO BLOQUEA EL MOVIMIENTO DE LOS ELEMENTOS
      this.canvas.getObjects().forEach((object) => {
        this.setStyleCorner(object);
        object.lockMovementX = flag ? true : false;
        object.lockMovementY = flag ? true : false;
        object.lockRotation = flag ? true : false;
        object.lockMovementX = flag ? true : false;
        object.lockMovementY = flag ? true : false;
        object.lockScalingX = flag ? true : false;
        object.lockScalingY = flag ? true : false;
        object.hasControls = flag ? false : true;
        // object.hasBorders = false;
      });
    },
    /**
     _________________________________________________________
    |          MÉTODOS SELECCIONAR MODOS DE PINCEL          */
    selectMode() {



      console.log(this.modoPincel.valor);

      if (this.modoPincel.valor === 'hline') {
        this.canvas.freeDrawingBrush = this.vLinePatternBrush;
      }
      else if (this.modoPincel.valor === 'vline') {
        this.canvas.freeDrawingBrush = this.hLinePatternBrush;
      }
      else if (this.modoPincel.valor === 'square') {
        this.canvas.freeDrawingBrush = this.squarePatternBrush;
      }
      else if (this.modoPincel.valor === 'diamond') {
        this.canvas.freeDrawingBrush = this.diamondPatternBrush;
      }
      else if (this.modoPincel.valor === 'texture') {
        this.canvas.freeDrawingBrush = this.texturePatternBrush;
      }
      else {

        switch (this.modoPincel.valor) {
          case 'Spray':
            this.canvas.freeDrawingCursor = `url('${brushIconSprayURL}') 0 0, auto`;
            break;

          default:
            this.canvas.freeDrawingCursor = `url('${brushIconURL}') 0 0, auto`;
            break;
        }
        this.canvas.freeDrawingBrush = new fabric[this.modoPincel.valor + 'Brush'](this.canvas);
      }

      if (this.canvas.freeDrawingBrush) {

        console.log('entraste ');

        let brush = this.canvas.freeDrawingBrush;
        brush.color = this.drawingColorEl;
        if (brush.getPatternSrc) {
          brush.source = brush.getPatternSrc.call(brush);
        }
        brush.width = parseInt(this.drawingLineWidthEl, 10) || 1;
        // brush.shadow = new fabric.Shadow({
        //   blur: parseInt(drawingShadowWidth.value, 10) || 0,
        //   offsetX: 0,
        //   offsetY: 0,
        //   affectStroke: true,
        //   color: drawingShadowColorEl.value,
        // });
      }

    },
    /**
     _______________________________________________________
    |          MÉTODOS SELECCIONAR COLOR PINCEL          */
    selectColorPincel() {
      var brush = this.canvas.freeDrawingBrush;
      brush.color = this.drawingColorEl;
      if (brush.getPatternSrc) {
        brush.source = brush.getPatternSrc.call(brush);
      }
    },
    /**
     _______________________________________________
    |          MÉTODOS GROSOR DEL PINCEL          */
    selectGrosorPincel() {
      this.canvas.freeDrawingBrush.width = parseInt(this.drawingLineWidthEl, 10) || 1;
      // this.previousSibling.innerHTML = this.value;
    },
    clearCanvas() {
      const objetos = this.canvas.getObjects();

      for (let i = objetos.length - 1; i >= 0; i--) {
        let obj = objetos[i];
        if (obj.data && obj.data.type === 'dibujo') {
          this.canvas.remove(obj);
        }
      }

      this.canvas.renderAll();
    },
    /**
     _______________________________________________
    |          MÉTODOS CERRAR COMPONENTE          */
    CloseComponent() {
      this.estadoModalConfig = false;
    },
  },
};
</script>

<style scoped>
.contentCanvas {
  display: flex;
  justify-content: space-around;
  background-color: white;
}

.buttons-diapos {
  display: table-cell;
  padding-top: 5px;
  padding-left: 10px;
}
</style>
